
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import * as tenantActions from '../../actions/tenantActions';
import {
    Grid,
    Row,
    Col,
    Image,
    FormGroup,
    FormControl,
    ControlLabel
} from "react-bootstrap";
//import "react-select/dist/react-select.css";
import Card from "../../components/Card/Card.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from "../../components/CustomButton/CustomButton.jsx";
import rest from "../../API/api";
import Datetime from "react-datetime";




class AddTenantForm extends Component {
    constructor(props) {
        super(props);
        this._grabUserInput = this._grabUserInput.bind(this);
        this._saveTenant = this._saveTenant.bind(this);
        this.isValidated = this.isValidated.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeSubscription = this.handleChangeSubscription.bind(this);
        this.handleChangeSubscriptionMultiShopCount = this.handleChangeSubscriptionMultiShopCount.bind(this);
        this.calculateSubscriptionPrice = this.calculateSubscriptionPrice.bind(this);
        /*
        this._fileChangedHandler1 =this._fileChangedHandler1.bind(this);
        this._fileChangedHandler2 =this._fileChangedHandler2.bind(this);
        this._fileChangedHandler3 =this._fileChangedHandler3.bind(this);
        */
        this.state = {
            Userid: this.props.tenant.Userid,
            Email:  this.props.tenant.Email,
            Company: this.props.tenant.Company,
            Fname: this.props.tenant.Fname,
            Lname: this.props.tenant.Lname,
            Address: this.props.tenant.Address,
            City: this.props.tenant.City,
            State: this.props.tenant.State,
            Country: this.props.tenant.Country,
            Postal: this.props.tenant.Postal,
            Phone: this.props.tenant.Phone,
            SubscriptionDate: this.props.tenant.SubscriptionDate,
            SubscriptionStatus: this.props.tenant.SubscriptionStatus,
            SubscriptionType: this.props.tenant.SubscriptionType,
            SubscriptionPrice: this.props.tenant.SubscriptionPrice,
            SubscriptionMultiShopCount: this.props.tenant.SubscriptionMultiShopCount,
            CustomerXRef: this.props.tenant.CustomerXRef,
            Role: this.props.tenant.Role,
            Password: this.props.tenant.Password,
            ConfirmPassword: this.props.tenant.ConfirmPassword,
            Hash: this.props.tenant.Hash,
            Salt: this.props.tenant.Salt,
            UseridError: null,
            EmailError: null,
            CompanyError: null,
            FnameError: null,
            LnameError: null,
            AddressError: null,
            CityError: null,
            CountryError: null,
            PostalError: null,
            RoleError: null,
            PasswordError: null,
            ConfirmPasswordError: null,
            SubscriptionDateError:null,
            SubscriptionTypeError:null,
            SubscriptionPriceError:null,
            SubscriptionMultiShopCountError:null,
        }
    }
    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }

    isValidated() {
        const userInput = this._grabUserInput(); // grab user entered vals
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var passwordRequirementsEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
        re.test(this.state.Email) === false
            ? this.setState({
                EmailError: (
                    <small className="text-danger">
                        Email is required and format should be <i>john@doe.com</i>.
                    </small>
                )
            })
            : this.setState({ EmailError: null });
        //check each required field for validation
        this.state.Userid === ""
            ? this.setState({
                UseridError: (
                    <small className="text-danger">
                        Please provide a User Id for this tenant.
                    </small>
                )
            })
            : this.setState({ UseridError: null });
        var ui = this.state.Userid !== "";


        this.state.Company=== ""
            ? this.setState({
                CompanyError: (
                    <small className="text-danger">
                        Please provide a company name for this tenant.
                    </small>
                )
            })
            : this.setState({ CompanyError: null });
        var cp = this.state.Company !== "";

        this.state.Fname === ""
            ? this.setState({
                FnameError: (
                    <small className="text-danger">
                        Please provide a first name for this tenant.
                    </small>
                )
            })
            : this.setState({ FnameError: null });
        var fn = this.state.Fname !== "";

        this.state.Lname === ""
            ? this.setState({
                LnameError: (
                    <small className="text-danger">
                        Please provide a last name for this tenant.
                    </small>
                )
            })
            : this.setState({ LnameError: null });
        var ln = this.state.Lname !== "";

        this.state.Address === ""
            ? this.setState({
                AddressError: (
                    <small className="text-danger">
                        Please provide an address for this tenant.
                    </small>
                )
            })
            : this.setState({ AddressError: null });
        var ad = this.state.Address !== "";

        this.state.City === ""
            ? this.setState({
                CityError: (
                    <small className="text-danger">
                        Please provide a city for this tenant.
                    </small>
                )
            })
            : this.setState({ CityError: null });
        var ct = this.state.City !== "";

        this.state.State === ""
            ? this.setState({
                StateError: (
                    <small className="text-danger">
                        Please provide a state for this tenant.
                    </small>
                )
            })
            : this.setState({ StateError: null });
        var st = this.state.State !== "";

        this.state.Country === ""
            ? this.setState({
                CountryError: (
                    <small className="text-danger">
                        Please provide a country for this tenant.
                    </small>
                )
            })
            : this.setState({ CountryError: null });
        var country = this.state.Country !== "";

        this.state.Postal === ""
            ? this.setState({
                PostalError: (
                    <small className="text-danger">
                        Please provide a postal code for this tenant.
                    </small>
                )
            })
            : this.setState({ PostalError: null });
        var postal = this.state.Postal !== "";

        this.state.Phone === ""
            ? this.setState({
                PhoneError: (
                    <small className="text-danger">
                        Please provide a phone number for this tenant.
                    </small>
                )
            })
            : this.setState({ PhoneError: null });
        var phone = this.state.Phone !== "";

        ((this.state.SubscriptionType === "Select a subscription type") || (this.state.SubscriptionType === ""))
            ? this.setState({
                SubscriptionTypeError: (
                    <small className="text-danger">
                        Please provide a subscription type.
                    </small>
                )
            })
            : this.setState({SubscriptionTypeError: null});
        var type = ((this.state.SubscriptionType !== "Select a subscription type") && (this.state.SubscriptionType !== ""));


        this.state.SubscriptionDate === ""
            ? this.setState({
                SubscriptionDateError: (
                    <small className="text-danger">
                        Please provide a subscription end date.
                    </small>
                )
            })
            : this.setState({SubscriptionDateError: null});
        var subscription = this.state.SubscriptionDate !== "";

        ((this.state.Role === "Select a role") || (this.state.Role === ""))
            ? this.setState({
                RoleError: (
                    <small className="text-danger">
                        Please provide a role for this tenant.
                    </small>
                )
            })
            : this.setState({RoleError: null});
        var role = ((this.state.Role !== "Select a role") && (this.state.Role !== ""));

        this.state.Password === ""
            ? this.setState({
                PasswordError: (
                    <small className="text-danger">
                        Please provide a password for this tenant.
                    </small>
                )
            })
            : this.setState({ PasswordError: null });
        var password = this.state.Password !== "";

        this.state.ConfirmPassword === ""
            ? this.setState({
                ConfirmPasswordError: (
                    <small className="text-danger">
                        Please provide the password again for this tenant.
                    </small>
                )
            })
            : this.setState({ ConfirmPasswordError: null });
        var confirm_password = this.state.ConfirmPassword !== "";

        passwordRequirementsEx.test(this.state.Password) === false
            ? this.setState({
                PasswordError: (
                    <small className="text-danger">
                        Password Requirements not met!.
                    </small>
                )
            })
            : this.setState({PasswordError: null});

        re.test(this.state.Userid) === false
            ? this.setState({
                UseridError: (
                    <small className="text-danger">
                        Userid must be formatted as an email address.
                    </small>
                )
            })
            : this.setState({UseridError: null});

        var valid = (ui &&  cp && fn && ln && ad && ct && st && country && postal && phone && type && subscription &&
            role && password && confirm_password && re.test(this.state.Email) && re.test(this.state.Userid) && passwordRequirementsEx.test(this.state.Password));
        if(valid)
            return valid;
    }

    passwordMismatchAlert(){
        this.setState({
                PasswordError: (
                    <small className="text-danger">
                        Password mismatch, please correct the passwords!
                    </small>
                ),
                ConfirmPasswordError: (
                    <small className="text-danger">
                        Password mismatch, please correct the passwords!
                    </small>
                )
            }
        );
    }

    duplicateUseridAlert(){
        this.setState({
                UseridError: (
                    <small className="text-danger">
                        Userid already exists!
                    </small>
                )
            }
        );
    }


    successAlert(saved){
        //Setup the alert and use the context to route to the Tenants once record is saved.
        if(saved) {
            this.setState({
                alert: (
                    <SweetAlert
                        success
                        title="Tenant added successfully!"
                        style={{display: "block"}}
                        onConfirm={() => this.context.router.history.push("/Tenants")}
                        onCancel={() => this.context.router.history.push("/Tenants")}
                        confirmBtnBsStyle="info"
                    >
                    </SweetAlert>
                )
            });
        }
        else
        {
            this.setState({
                alert: (
                    <SweetAlert
                        danger
                        style={{display: "block"}}
                        title="Error updating this tenant record, Please try again!"
                        onConfirm={() => this.setState({alert: null})}
                        onCancel={() => this.setState({alert: null})}
                        confirmBtnBsStyle="danger"
                    >
                    </SweetAlert>
                )
            });
        }
    }
/*
    _fileChangedHandler1 = event => {
        event.preventDefault();

        let reader = new FileReader();
        let file = event.target.files[0];

        reader.onloadend = () => {
            this.setState({
                image1PreviewUrl: reader.result,
            });
        }
        reader.readAsDataURL(file);
        //console.log(event.target.files[0]);
    };
    _fileChangedHandler2 = event => {
        event.preventDefault();

        let reader = new FileReader();
        let file = event.target.files[0];

        reader.onloadend = () => {
            this.setState({
                image2PreviewUrl: reader.result,
            });
        }
        reader.readAsDataURL(file);
    };
    _fileChangedHandler3 = event => {
        event.preventDefault();

        let reader = new FileReader();
        let file = event.target.files[0];

        reader.onloadend = () => {
            this.setState({
                image3PreviewUrl: reader.result,
            });
        }
        reader.readAsDataURL(file);
    };

*/
    _grabUserInput() {
        var crypto = require('crypto');
        //assign the Salt, generate the hash based on the password provided
        let mySalt = crypto.randomBytes(16).toString('hex');
        let myHash = crypto.pbkdf2Sync(document.getElementById('Password').value, mySalt, 1000, 64, 'sha512').toString('hex');
        var subscriptionStatus = false;
        var tenantDate = new Date(this.state.SubscriptionDate);
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        var today_s = mm + '/' + dd + '/' + yyyy;
        var todayDate = new Date(today_s);
        subscriptionStatus = tenantDate - todayDate >= 0;
        //Lets store the subscription date into a mm/dd/yyyy string
        dd = tenantDate.getDate();
        mm = tenantDate.getMonth() + 1; //January is 0!
        yyyy = tenantDate.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        var tenantDate_s = mm + '/' + dd + '/' + yyyy;


        return {
            id: this.props.id,
            Userid: document.getElementById('Userid').value,
            Email: document.getElementById('Email').value,
            Company: document.getElementById('Company').value,
            Fname: document.getElementById('Fname').value,
            Lname: document.getElementById('Lname').value,
            Address: document.getElementById('Address').value,
            City: document.getElementById('City').value,
            State: document.getElementById('State').value,
            Country: document.getElementById('Country').value,
            Postal: document.getElementById('Postal').value,
            Phone: document.getElementById('Phone').value,
            SubscriptionDate: tenantDate_s,
            SubscriptionStatus: subscriptionStatus,
            SubscriptionType: ReactDOM.findDOMNode(this.subscriptionType).value,
            SubscriptionMultiShopCount: document.getElementById('MultiShopCount').value,
            SubscriptionPrice: document.getElementById('SubscriptionPrice').value,
            CustomerXRef: document.getElementById('CustomerXRef').value,
            Password: document.getElementById('Password').value,
            ConfirmPassword: document.getElementById('ConfirmPassword').value,
            Role: ReactDOM.findDOMNode(this.select).value,
            Salt: mySalt,
            Hash: myHash
        };
    }

    _saveTenant(event) {
        event.preventDefault();
        //Check to see if the userid exists, then check passwords and finally check rest of fields
        fetch(rest.getUserSalt, {
            method: 'POST',
            body: JSON.stringify({
                username: document.getElementById('Userid').value

            }),
            insecure: true,
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': rest.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                //Check for duplicate User ID
                if (data.exist) {
                    //console.log(data);
                    this.duplicateUseridAlert();
                    return;
                }
                //Check to see if the passwords match
                if ((document.getElementById('Password').value) !== (document.getElementById('ConfirmPassword').value)) {
                    this.passwordMismatchAlert();
                    return;
                }
                //now check the rest of the fields if they are good write the record
                if (this.isValidated()) {
                    //Call save tenant Thunk and pass it the current form values
                    let userInput = this._grabUserInput();
                    this.props.tenantActions.addTenant(this.props.userLoggedIn[0],userInput);
                    this.successAlert(true);
                }
            })
            .catch(error => console.error(error));
    }

    calculateSubscriptionPrice= () => {
        //Lets get the subscription type and multi-shop count values and calculate their price.
        let count_s = document.getElementById('MultiShopCount').value;
        let type_s = ReactDOM.findDOMNode(this.subscriptionType).value;
        var todayDate = new Date();
        var tenantDate,mm,dd,yyyy;
        var tenantDate_s = "";
        let price = 0;
        switch(type_s){
            case "Monthly" :
                price = rest.Monthly + (count_s * rest.MultiShop);
                tenantDate = new Date(todayDate.setMonth(todayDate.getMonth()+2));
                //Lets store the subscription date into a mm/dd/yyyy string
                dd = tenantDate.getDate();
                mm = tenantDate.getMonth() + 1; //January is 0!
                yyyy = tenantDate.getFullYear();
                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                tenantDate_s = mm + '/' + "05" + '/' + yyyy;
                break;
            case "Yearly" :
                price = rest.Yearly + (count_s * rest.MultiShop * 12);
                tenantDate = new Date(todayDate.setMonth(todayDate.getMonth()+13));
                //Lets store the subscription date into a mm/dd/yyyy string
                dd = tenantDate.getDate();
                mm = tenantDate.getMonth() + 1; //January is 0!
                yyyy = tenantDate.getFullYear();
                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                tenantDate_s = mm + '/' + "05" + '/' + yyyy;
                break;
            default:
                price = count_s * rest.MultiShop;
        }
        this.setState({
            SubscriptionPrice: price,
            SubscriptionDate: tenantDate_s
        });
    };


    handleChange= () => {
        //console.log(ReactDOM.findDOMNode(this.select).value);
        this.setState({ Role: ReactDOM.findDOMNode(this.select).value });
    };

    handleChangeSubscription = () => {
        this.setState({ SubscriptionType: ReactDOM.findDOMNode(this.subscriptionType).value });
        this.calculateSubscriptionPrice();
    };

    handleChangeSubscriptionMultiShopCount = () => {
        this.setState({ SubscriptionMultiShopCount: document.getElementById('MultiShopCount').value });
        this.calculateSubscriptionPrice();
    };

    render() {
        //debugger;
        if (this.props.userLoggedIn[0].role === "Admin") {
            return (
                <div className="main-content" style={{ backgroundImage: "url(" + require("../../assets/img/matrix.jpg") + ")" }}>
                    <Grid fluid>
                        <Card
                            content={
                                <div>
                                    <legend>Add: Basic Tenant Information</legend>
                                    <Row>
                                        <Col md={5} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>First Name <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Fname"
                                                    type="text"
                                                    name="first_name"
                                                    placeholder="ex: Mike"
                                                    value={this.state.Fname}
                                                    onChange={event => this.setState({Fname: event.target.value})}
                                                />
                                                {this.state.FnameError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <ControlLabel>Last Name <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Lname"
                                                    type="text"
                                                    name="last_name"
                                                    placeholder="ex: Andrew"
                                                    value={this.state.Lname}
                                                    onChange={event => this.setState({Lname: event.target.value})}
                                                />
                                                {this.state.LnameError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Company <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Company"
                                                    type="text"
                                                    name="company"
                                                    placeholder="ex: My Sweet Company Name"
                                                    value={this.state.Company}
                                                    onChange={event => this.setState({Company: event.target.value})}
                                                />
                                                {this.state.CompanyError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <ControlLabel>Address <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Address"
                                                    type="text"
                                                    name="address"
                                                    placeholder="ex: 8675 County Road 309"
                                                    value={this.state.Address}
                                                    onChange={event => this.setState({Address: event.target.value})}
                                                />
                                                {this.state.AddressError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>City <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="City"
                                                    type="text"
                                                    name="city"
                                                    placeholder="ex: Elizabeth"
                                                    value={this.state.City}
                                                    onChange={event => this.setState({City: event.target.value})}
                                                />
                                                {this.state.CityError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup>
                                                <ControlLabel>State <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="State"
                                                    type="text"
                                                    name="state"
                                                    placeholder="ex: Colorado"
                                                    value={this.state.State}
                                                    onChange={event => this.setState({State: event.target.value})}
                                                />
                                                {this.state.StateError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <ControlLabel>Postal Code <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Postal"
                                                    type="text"
                                                    name="postal"
                                                    placeholder="ex: 80107"
                                                    value={this.state.Postal}
                                                    onChange={event => this.setState({Postal: event.target.value})}
                                                />
                                                {this.state.PostalError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Country <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Country"
                                                    type="text"
                                                    name="country"
                                                    placeholder="ex: USA"
                                                    value={this.state.Country}
                                                    onChange={event => this.setState({Country: event.target.value})}
                                                />
                                                {this.state.CountryError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <ControlLabel>
                                                    Email <span className="text-danger">*</span>
                                                </ControlLabel>
                                                <FormControl
                                                    id="Email"
                                                    type="email"
                                                    name="email"
                                                    value={this.state.Email}
                                                    placeholder="ex: dd@disney.com"
                                                    onChange={event => this.setState({Email: event.target.value})}
                                                />
                                                {this.state.EmailError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Phone Number <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Phone"
                                                    type="text"
                                                    name="Phone"
                                                    placeholder="303-867-5309"
                                                    value={this.state.Phone}
                                                    onChange={event => this.setState({Phone: event.target.value})}
                                                />
                                                {this.state.PhoneError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={2} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Subscription type <span className="text-danger">*</span> </ControlLabel>
                                                <FormControl componentClass="select"
                                                             placeholder="Select a subscription type"
                                                             ref={subscriptionType => { this.subscriptionType= subscriptionType }}
                                                             onChange={this.handleChangeSubscription}
                                                             value={this.state.SubscriptionType}
                                                >
                                                    <option value="Select a subscription type">Select a subscription type</option>
                                                    <option value="Monthly">Monthly</option>
                                                    <option value="Yearly">Yearly</option>
                                                </FormControl>
                                                {this.state.SubscriptionTypeError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup>
                                                <ControlLabel>Multi-Shop Count: <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="MultiShopCount"
                                                    type="text"
                                                    name="multishopcount"
                                                    placeholder="ex: 0"
                                                    value={this.state.SubscriptionMultiShopCount}
                                                    onChange={this.handleChangeSubscriptionMultiShopCount}
                                                    //onChange={event => this.setState({SubscriptionMultiShopCount: event.target.value})}
                                                />
                                                {this.state.SubscriptionMultiShopCountError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup>
                                                <ControlLabel>Price (USD): <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="SubscriptionPrice"
                                                    type="number"
                                                    name="subscriptionprice"
                                                    placeholder="99"
                                                    value={this.state.SubscriptionPrice}
                                                    disabled={true}
                                                    //onChange={event => this.setState({SubscriptionPrice: event.target.value})}
                                                />
                                                {this.state.SubscriptionPriceError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Subscription End Date <span className="text-danger">*</span> </ControlLabel>
                                                <Datetime
                                                    id="subscriptionDate"
                                                    timeFormat={false}
                                                    inputProps={{placeholder: "Choose a Subscription End Date"}}
                                                    value={this.state.SubscriptionDate}
                                                    //onChange={this.handleChange}
                                                    onChange={value => this.setState({ SubscriptionDate: value })}
                                                />
                                                {this.state.SubscriptionDateError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} >
                                            <FormGroup>
                                                <ControlLabel>Customer External Reference </ControlLabel>
                                                <FormControl
                                                    id="CustomerXRef"
                                                    type="text"
                                                    name="CustomerXRef"
                                                    placeholder="ex: CUST99999"
                                                    value={this.state.CustomerXRef}
                                                    onChange={event => this.setState({CustomerXRef: event.target.value})}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        />
                        <Card
                            content={
                                <div>
                                    <legend>Add: Tenant Authentication Information</legend>
                                    <Row>
                                        <Col md={10} mdOffset={1}>
                                            <hr />
                                            <h6>User Ids should be formatted as an email address and must be unqiue to TRO.
                                                <br />All passwords must meet the following guidelines:<br />
                                                <ul>
                                                    <li>Password must contain at least 1 lowercase alphabetical character</li>
                                                    <li>Password must contain at least 1 uppercase alphabetical character</li>
                                                    <li>Password must contain at least 1 numeric character</li>
                                                    <li>Password must contain at least one special character</li>
                                                    <li>Password must be eight characters or longer</li>
                                                </ul>
                                            </h6>
                                            <hr />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>User ID <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Userid"
                                                    type="text"
                                                    name="userid"
                                                    placeholder="ex: joe@joe.com"
                                                    value={this.state.Userid}
                                                    onChange={event => this.setState({Userid: event.target.value})}
                                                />
                                                {this.state.UseridError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup>
                                                <ControlLabel>Please select a role. <span className="text-danger">*</span> </ControlLabel>
                                                <FormControl componentClass="select"
                                                             placeholder="Select a role"
                                                             ref={select => { this.select = select }}
                                                             onChange={this.handleChange}
                                                             value={this.state.Role}
                                                >
                                                    <option value="Select a role">Select a role</option>
                                                    <option value="User">User</option>
                                                    <option value="Admin">Admin</option>
                                                </FormControl>
                                                {this.state.RoleError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Password <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Password"
                                                    type="password"
                                                    name="password"
                                                    placeholder="ex: 1Swe456#@$"
                                                    value={this.state.Password}
                                                    onChange={event => this.setState({Password: event.target.value})}
                                                />
                                                {this.state.PasswordError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup>
                                                <ControlLabel>Confirm Password <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="ConfirmPassword"
                                                    type="password"
                                                    name="confirm_password"
                                                    placeholder="ex: 1Swe456#@$"
                                                    value={this.state.ConfirmPassword}
                                                    onChange={event => this.setState({ConfirmPassword: event.target.value})}
                                                />
                                                {this.state.ConfirmPasswordError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={1} xs={5} xsOffset={1}>
                                            <Button bsStyle="info" pullRight fill wd onClick={this._saveTenant}>
                                                Save
                                            </Button>
                                        </Col>
                                        <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                            <Button bsStyle="info" pullRight fill wd onClick={ async () => {
                                                let tURL = "/tenants";
                                                await this.context.router.history.push(tURL);
                                            }}>
                                                Cancel
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        />
                        {this.state.alert}
                    </Grid>
                </div>
            );
        }
        else {
            alert("You must be logged in and have an active subscription to access this page!");
            this.context.router.history.push("/pages/login-page");
            return(null);
        }
    }
}

AddTenantForm.propTypes = {
    loginActions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired,
    tenant: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        userLoggedIn: state.userLoggedIn,
        tenant: state.tenant,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        tenantActions: bindActionCreators(tenantActions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddTenantForm);



// WEBPACK FOOTER //
// ./src/views/Forms/AddTenant.jsx